import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import styled from "styled-components";
import { FormattedMessage } from "react-intl";
import { ProgressSpinner } from 'primereact/progressspinner';
import { API_BASE_URL, API_URLS, LOCALSTORAGE_TOKEN_ITEM } from "constants/api";
import { Routes } from "constants/routes";
import { useGoogleLogin, TokenResponse } from "@react-oauth/google";
import Google from "assets/google.svg";
import Facebook from "assets/facebook-up.svg"
import Apple from "assets/apple-up.svg"
import { Text } from "./Text";
import FacebookLogin from "react-facebook-login/dist/facebook-login-render-props";
import AppleLogin from "react-apple-login";


export const SocialNetworks = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

 
  const handleSocialLogin = async (provider: "google" | "facebook" | "apple", token: string) => {
    try {
      setLoading(true);
      const response = await axios.post(`${API_BASE_URL}${API_URLS.AuthSocial}`, {
        provider,
        token,
      });
      const responseData = response?.data;

      if (responseData) {
        const { data, success } = responseData;

        if (success && data) {
          localStorage.setItem(LOCALSTORAGE_TOKEN_ITEM, data.token);
          navigate(Routes.General);
        }
      }
    } catch (e: any) {
      const message = e.response?.data?.message || "Authentication failed";
      console.error("Error", message);
      toast.error(message);
    } finally {
      setLoading(false);
    }
  };


  const googleLogin = useGoogleLogin({
    onSuccess: async (token: TokenResponse) => {
      await handleSocialLogin("google", token.access_token);
    },
  });


  const facebookResponse = async (response: any) => {
    if (response.accessToken) {
      await handleSocialLogin("facebook", response.accessToken);
    } else {
      toast.error("Facebook login failed");
    }
  };

  const appleResponse = async (response: any) => {
    if (response.authorization?.id_token) {
      await handleSocialLogin("apple", response.authorization.id_token);
    } else {
      toast.error("Apple login failed");
    }
  };

  return (
    <Container>
      {loading && (
        <Loading>
          <ProgressSpinner />
        </Loading>
      )}

      <Text>
        <FormattedMessage id="Auth.SignUp.ContinueWith" defaultMessage="Continue with" />
      </Text>

      <Row>
        <StyledButton type="button" onClick={() => googleLogin()} tabIndex={-1}>
          <Google />
          Google
        </StyledButton>

        <AppleLogin
          clientId="YOUR_APPLE_CLIENT_ID"
          redirectURI="dashboard.slashmusic.net/"
          responseType={"id_token"}
          responseMode={"fragment"}
          usePopup={true}
          callback={appleResponse}
          render={(renderProps: any) => (
            <StyledButton type="button" onClick={renderProps.onClick} tabIndex={-1}>
              <Apple />
              Apple
            </StyledButton>
          )}
        />

        <FacebookLogin
          appId="YOUR_FACEBOOK_APP_ID"
          autoLoad={false}
          callback={facebookResponse}
          render={(renderProps: any) => (
            <StyledButton type="button" onClick={renderProps.onClick} tabIndex={-1}>
              <Facebook />
              Facebook
            </StyledButton>
          )}
        />

        
        
      </Row>
    </Container>
  );
};


const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

const Row = styled.div`
  display: flex;
  gap:9px;
`;

const StyledButton = styled.button`
  background: #fff;
  border-radius: 30px;
  height: 50px;
  width: 140px;
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  font-weight: 400;
  cursor: pointer;
  border: none;
  outline: none;
  transition: all 0.3s ease;

  &:hover {
  box-shadow: 0px 0px 10px 2px rgba(103, 119, 255, 0.7);

  }

  
`;


const Loading = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 1000;
`;
